import {
    splitPathAndFileName,
    testFileName,
} from '../../../utility/urlHelpers.new';
import {
    paramCreateDirectory,
    paramDsName,
    paramFileName,
    paramOverwrite,
    paramPath,
} from '../constants/parameterNames';
import { typeBoolean, typeDataSource } from '../constants/parameterTypes';
import { stringToBase64Raw } from '../helpers/attachmentHelpers';
import { success } from '../helpers/commandResult';
import {
    getBoolParamValue,
    getParamValue,
} from '../helpers/parameter.accessors';
import { getDataSourceContents } from '../helpers/qRules.node.helpers';

const description =
    'Submits the contents of a data source to a local network location. Only supported on FormsViewer instances that have this feature enabled.';

const requiredParameters = {
    [paramPath]: {
        description: `Path to submit the file to. If /${paramFileName} is specified, assumes this is the path to a folder where the file should be saved. Otherwise, assumes this is the full file path.`,
    },
};

const optionalParameters = {
    [paramFileName]: {
        description: `The name of the file to save. Can be omitted if filename is inclued in /${paramPath}`,
    },
    [paramDsName]: {
        description:
            'The data source whose contents should be submitted. If not specified, assumes the current data source.',
        type: typeDataSource,
    },
    [paramCreateDirectory]: {
        description: `(boolean, false by default) Create target directory if it does not exist. Otherwise, will fail if the directory does not exist.`,
        type: typeBoolean,
    },
    [paramOverwrite]: {
        description: `(boolean, false by default) Overwrite target file if it exists. Otherwise, will fail if the file exists.`,
        type: typeBoolean,
    },
};

const getPathAndFileName = (fileName, path) => {
    if (fileName) {
        return {
            path,
            fileName,
        };
    }

    return splitPathAndFileName(path);
};

async function executeAsync({ api, dataSources, parameters }) {
    const dsName = getParamValue(parameters, paramDsName);
    const path = getParamValue(parameters, paramPath);
    const fileName = getParamValue(parameters, paramFileName);
    const createDirectory = getBoolParamValue(parameters, paramCreateDirectory);
    const overwrite = getBoolParamValue(parameters, paramOverwrite);

    const contents = getDataSourceContents(dataSources, dsName);

    const { path: actualPath, fileName: actualFileName } = getPathAndFileName(
        fileName,
        path,
    );

    if (!actualPath) {
        throw new Error('Could not determine folder path to save to.');
    }
    if (!actualFileName) {
        throw new Error('Could not determine file name.');
    }

    testFileName(actualFileName);

    const result = await api.uploadNetworkFileAsync(
        createDirectory,
        actualFileName,
        stringToBase64Raw(contents),
        overwrite,
        actualPath,
    );

    if (!result.success) {
        throw new Error(
            result.error?.Message || 'There was an error while uploading file',
        );
    }

    return success();
}

const SubmitToNetwork = {
    executeAsync,
    optionalParameters,
    requiredParameters,
    description,
};

export default SubmitToNetwork;
